var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_vm._t("header"),_vm._v(" "),(_vm.showNoAnalyticsPermissions)?[_vm._t("no-access",function(){return [_c('ReportsNoAccess')]})]:(_vm.showUpsell)?_c('ReportsUpsell'):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }